import { render, staticRenderFns } from "./cordx-tyfast-ovulation-test-pregnancy-test-combo_pc.vue?vue&type=template&id=15343ffc&scoped=true&"
import script from "./cordx-tyfast-ovulation-test-pregnancy-test-combo_pc.vue?vue&type=script&lang=js&"
export * from "./cordx-tyfast-ovulation-test-pregnancy-test-combo_pc.vue?vue&type=script&lang=js&"
import style0 from "./cordx-tyfast-ovulation-test-pregnancy-test-combo_pc.vue?vue&type=style&index=0&id=15343ffc&scoped=true&lang=less&"
import style1 from "./cordx-tyfast-ovulation-test-pregnancy-test-combo_pc.vue?vue&type=style&index=1&id=15343ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15343ffc",
  null
  
)

export default component.exports